<div>
  <label *ngIf="label">{{ label }} <span *ngIf="required">*</span></label>

  <input
    #inputEl
    class="input"
    type="text"
    [attr.placeholder]="placeholder"
    [disabled]="disabled"
    [value]="value"
    (input)="onInput($event)"
    (blur)="onBlur()"
    [class.!border-red-500]="invalid && touched"
  />
</div>
